import React, { useState, useEffect } from 'react';
import CustomSimpleDialog from '../../../../components/CustomDialog/CustomSimpleDialog';
import Loader from '../../../../components/Loader/Loader';
import axios from 'store/axios/axios-invoice';
import axiosRS from 'store/axios/axios-rs';
import { formatUTCtoPST, handleError } from '../../../../shared/utility';
import Notification from '../../../../components/Notification/Notification';
import ReactTable from "react-table";
import { IconButton } from '@material-ui/core';
import { invoiceStatusDescription } from '../../../Invoices/InvoiceObj';
import { statusDescriptions } from '../../../RSheets/RSheetsLogic';
import Button from '../../../../components/CustomButtons/Button';
import { getUser } from '../../../../shared/authValidation';

const name = 'Invoice(s)';

const InvoiceSubTab = (props) => {
    const [openedChooseRS, setOpenedChooseRS] = useState(null);
    const [rs_entries, set_rs_entries] = useState([]);
    const [entries, setEntries] = useState([]);
    const [loading, setLoading] = useState(false);
    const [notification, setNotification] = useState('');
    const { permsAll, perms } = props;

    const loadRS = async () => {
        setLoading(true);
        try {
            console.log('loadding RS');
            const response = await axiosRS.get('/rsheets?property_id='+props.property_id);
            console.log('loading', response.data);
            if (!response.data) throw "Could not load " + name;
            set_rs_entries(response.data);
            setLoading(false);
        } catch(e) {
            handleError(e);
            setNotification('Could not load '+name+', please try again.');
            setLoading(false);
        }
    }

    const load = async () => {
        setLoading(true);
        try {
            // get Rsheets
            console.log('loadding RS');
            const response = await axiosRS.get('/rsheets?property_id='+props.property_id);
            console.log('loading', response.data);
            if (!response.data) throw "Could not load " + name;
            const rss = response.data;
            let invoices = [];
            for (let i = 0; i < rss.length; i++) {
                const rs = rss[i];
                try {
                    const invoice_response = await axios.get('/entries?rs_id='+rs.id);
                    console.log('loading invoice', invoice_response.data);
                    invoice_response.data.forEach(invoice => {
                        invoices.push(invoice);
                    })
                } catch(e2) {
                    handleError(e2);
                }
            }
        
            setEntries(invoices);
            setLoading(false);
        } catch(e) {
            handleError(e);
            setNotification('Could not load '+name+', please try again.');
            setLoading(false);
            setEntries([]);
        }
    }

    const loadEntry = async () => {
        setLoading(true);
        try {
            const response = await axios.get('/entry?property_id='+props.property_id);
            console.log('loading', response.data);
            if (!response.data) throw "Could not load ERTL";
            setEntries(response.data);
            setLoading(false);
        } catch(e) {
            handleError(e);
            setNotification('Could not load ERTL, please try again.');
            setLoading(false);
        }
    }

    useEffect(() => {
        load();
    }, []);

    const defaultSorted = props.defaultSorted
        ? props.defaultSorted
        : [
              {
                  id: "date",
                  desc: true,
              },
          ];

    const columns = [
        {
            Header: "ID #",
            accessor: "id" 
        },
        {
            Header: "Invoice #",
            accessor: "invoice_num" 
        },
        {
            Header: "RS #",
            accessor: "rs_id" 
        },
        {
            Header: "Date Created",
            accessor: "created_date"
        },
        {
            Header: "Date Modified",
            accessor: "modified_date"
        },
        {
            Header: "Status",
            accessor: "status"
        },
        {
            Header: "Submitter",
            accessor: "name"
        },
        {
            Header: "Actions",
            accessor: "actions"
        }
    ]

    const columns_rs = [
        {
            Header: "ID #",
            accessor: "id" 
        },
        {
            Header: "Date Created",
            accessor: "created_date"
        },
        {
            Header: "Date Modified",
            accessor: "modified_date"
        },
        {
            Header: "Status",
            accessor: "status"
        },
        {
            Header: "Submitter",
            accessor: "name"
        },
        {
            Header: "Actions",
            accessor: "actions"
        }
    ]

    console.log('InvoiceSubTab', props, entries);

    const usr = getUser();

    return (
        <div>
            {permsAll.indexOf('Invoice edit') !== -1 &&
                                <Button color="primary"
                                    onClick={() => {
                                        loadRS(props.property_id);
                                        setOpenedChooseRS(props.property_id);
                                    }}
                                >Create New {name}</Button>}

            {loading && <Loader center={true} /> }

            {entries.length === 0 && <p>No Entry.</p>}

            <div className="react-table-hover-gray">
                <ReactTable
                    defaultSorted={defaultSorted}
                    data={entries.map(entry => {
                        let additional = '';
                        if (usr.id === entry.user_id) {
                            // OWNER
                            if (entry.status === 0) {
                                // DRAFT 
                                additional = '/invoices?p=open&invoice_id='+entry.id;
                            }
                        }
                        if (entry.status === 3) {
                            // APPROVED
                            additional = '/invoices?p=open&invoice_id='+entry.id;
                        }
                        return {
                            id: entry.id,
                            invoice_num: entry.invoice_num,
                            rs_id: entry.rs_id,
                            created_date: formatUTCtoPST(entry.date_created),
                            modified_date: formatUTCtoPST(entry.date_modified),
                            status: invoiceStatusDescription[entry.status] ? invoiceStatusDescription[entry.status] : '',
                            name: entry.name,
                            actions: <div>
                                {additional && <IconButton
                                    onClick={() => {
                                        window.location.href = additional;
                                    }}
                                >
                                    <i className="fa fa-eye"></i>
                                </IconButton>}
                                {!additional && <div style={{opacity:0}}><IconButton
                                    onClick={() => {
                                        
                                    }}
                                >
                                    <i className="fa fa-eye"></i>
                                </IconButton></div>}
                            </div>
                        }
                    })}
                    className="-striped"
                    showPaginationTop
                    showPaginationBottom
                    columns={columns}
                    resizable
                    defaultPageSize={10}
                    pageSizeOptions={[10, 20, 30]}
                    minRows={10}
                    filterable
                />
            </div>

            {notification && <Notification 
                open={true}
                close={() => {
                    setNotification('');
                }}
                message={notification}
            />}

            {openedChooseRS && <CustomSimpleDialog 
                open={true}
                close={() => {
                    setOpenedChooseRS(null);
                }}
                content={<div>
                    <h3>Choose RS</h3>
                    <div className="react-table-hover-gray">
                        <ReactTable
                            defaultSorted={defaultSorted}
                            data={rs_entries.map(entry => {
                                return {
                                    id: entry.id,
                                    created_date: formatUTCtoPST(entry.date_created),
                                    modified_date: formatUTCtoPST(entry.date_modified),
                                    status: statusDescriptions[entry.status] ? statusDescriptions[entry.status] : '',
                                    name: entry.name,
                                    actions: <div>
                                        <Button
                                            color="rose"
                                            onClick={() => {
                                                window.location.href = '/invoices?p=open&rs_id='+entry.id
                                            }}
                                        >
                                            CHOOSE
                                        </Button>
                                    </div>
                                }
                            })}
                            className="-striped"
                            showPaginationTop
                            showPaginationBottom
                            columns={columns_rs}
                            resizable
                            defaultPageSize={10}
                            pageSizeOptions={[10, 20, 30]}
                            minRows={10}
                            filterable
                        />
                    </div>
                </div>}
            />}
        </div>
    );
};

export default InvoiceSubTab;
